import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Output()
  clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @Input()
  public buttonType: string = '';

  @HostBinding('class.disabled')
  @Input()
  public disabled: boolean = false;

  // Calling the Event emitter directly from the template might be bad practice for lager components!
  // Thus even for this simple one we have a local binding and controller logic
  click() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
